import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { useWorkflowContext } from '../../../contexts/WorkflowContext';
import { Vehicle } from '../../../types/api.graphql';
import {
  ActiveIndicator,
  Container,
  SideContentContainer,
  StyledButton,
  StyledVehicleChatPlaceholder,
  TitleText,
  VehicleImg,
  VehicleInfoContainer,
  VehicleStatus,
  WatchingNowContainer,
} from './VehicleChatTopView.styles';

interface VehicleChatTopViewProps {
  vehicle?: Vehicle;
}

const VehicleChatTopView = ({ vehicle }: VehicleChatTopViewProps) => {
  const { t } = useTranslation();
  const { statuses } = useWorkflowContext();
  const pictureUrl = vehicle?.pictures?.[0]?.url;
  const navigate = useNavigate();
  const location = useLocation();

  const actualVehicleVDPUrl = `/app/listings/${vehicle.id}`;

  const watchingNow = location.pathname === actualVehicleVDPUrl;

  const currentVehicleStatusDescription = statuses?.find(
    (status) => status.key === vehicle?.currentVehicleStatus?.name,
  )?.name;

  return (
    <Container>
      <SideContentContainer>
        {pictureUrl ? <VehicleImg src={pictureUrl} /> : <StyledVehicleChatPlaceholder />}
        <VehicleInfoContainer>
          <TitleText>{vehicle?.displayName}</TitleText>
          <VehicleStatus>{currentVehicleStatusDescription}</VehicleStatus>
        </VehicleInfoContainer>
      </SideContentContainer>
      <SideContentContainer>
        {watchingNow ? (
          <WatchingNowContainer>
            <TitleText>{t('components.chat.watchingNow')}</TitleText>
            <ActiveIndicator />
          </WatchingNowContainer>
        ) : (
          <StyledButton onPress={() => navigate(actualVehicleVDPUrl)}>{t('components.chat.goToDetails')}</StyledButton>
        )}
      </SideContentContainer>
    </Container>
  );
};

export default VehicleChatTopView;
